import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-met-inhoudingsvrijstelling',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-met-inhoudingsvrijstelling.component.html',
  styleUrl: './tekst-met-inhoudingsvrijstelling.component.scss',
})
export class TekstMetInhoudingsvrijstellingComponent {}
